import * as React from 'react';
import {
  Logging,
  ControlState,
  ControlStyleClass,
  renderEdit,
  Contact,
  ControlValidation,
  countryAbbreviationToName,
  stateProvinceAbbreviationToName,
} from '@vcd-ecm-ui/Common';
import CustomerContactProps from './CustomerContactProps.interface';
import '../../customer-info.scss';

const controlState: ControlState = {
  editable: false,
  disabled: true,
  readOnly: true,
};

const controlStyle: ControlStyleClass = null;

const controlValidation: ControlValidation = {
  // Empty Validation
};

const CustomerContact = ({ customer }: CustomerContactProps): JSX.Element => {
  Logging.Debug('Customer Contact');

  const contact: Contact = customer.contacts ? customer.contacts[0] : null;

  const [name, setName] = React.useState(contact ? contact.name : null);
  const [department, setDepartment] = React.useState(contact ? contact.department : null);
  const [email, setEmail] = React.useState(contact ? contact.email : null);
  const [phone, setPhone] = React.useState(contact ? contact.phone : null);
  const [phoneExtension, setPhoneExtension] = React.useState(contact ? contact.phoneExtension : null);
  const [fax, setFax] = React.useState(contact ? contact.fax : null);
  const [address, setAddress] = React.useState(contact ? contact.address : null);
  const [address2, setAddress2] = React.useState(contact ? contact.address2 : null);
  const [city, setCity] = React.useState(contact ? contact.city : null);
  const [state, setState] = React.useState(contact ? stateProvinceAbbreviationToName(contact.state) : null);
  const [postalCode, setPostalCode] = React.useState(contact ? contact.postalCode : null);
  const [country, setCountry] = React.useState(contact ? countryAbbreviationToName(contact.country) : null);

  return (
    <div className="generalContainer">
      {renderEdit(25, 'contact-name', 'Contact Name', 'text', null, name, setName, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'department', 'Department', 'text', null, department, setDepartment, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-email', 'E-Mail', 'email', null, email, setEmail, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-phone', 'Phone Number', 'tel', null, phone, setPhone, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-phone-extension', 'Extension', 'text', null,
        phoneExtension, setPhoneExtension, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-fax', 'Fax Number', 'tel', null, fax, setFax, controlState, controlStyle, controlValidation)}
      <div className="field25" />
      <div className="field25" />
      {renderEdit(25, 'contact-address', 'Street Address', 'text', null, address, setAddress, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-address-2', 'Street Address 2', 'text', null, address2, setAddress2, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-city', 'City', 'text', null, city, setCity, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-province-state', 'State / Province', 'text', null, state, setState, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-postal-zip', 'Postal / Zip Code', 'text', null,
        postalCode, setPostalCode, controlState, controlStyle, controlValidation)}
      {renderEdit(25, 'contact-country', 'Country', 'text', null, country, setCountry, controlState, controlStyle, controlValidation)}
    </div>
  );
};

export default CustomerContact;
